export default __webpack_public_path__ + "static/media/AutomationUpdateRecord.b8518dad.svg";